define([
    "./_base"
], function(csiAccess) {

	return function() {
		// summary: takes arguments as role names or arrays of role names
		// and create a hash object with full access
		return csiAccess.convertRolesArrayIntoHash([].concat.apply([],arguments),csiAccess.RESOURCE_FULL_ACCESS);
	};
});